import { render, staticRenderFns } from "./section-title.vue?vue&type=template&id=4937e27b&scoped=true"
import script from "./section-title.vue?vue&type=script&lang=js"
export * from "./section-title.vue?vue&type=script&lang=js"
import style0 from "./section-title.vue?vue&type=style&index=0&id=4937e27b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4937e27b",
  null
  
)

export default component.exports